import { ReactElement } from 'react';
import Head from 'next/head';
import { EVENT_HOST } from 'common';
import { useRouter } from 'next/router';

export interface FeedHeadProps {
  title: string;
  description: string;
  metaTitle?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  image?: string;
  webviewTitle?: string;
  canonical?: string;
  pageId?: string;
  pageParams?: object;
  siteName?: string;
}

export default function FeedHead({
  title,
  description,
  metaTitle,
  ogTitle,
  ogDescription,
  ogType,
  image,
  webviewTitle,
  canonical,
  pageId,
  pageParams,
  siteName,
}: FeedHeadProps): ReactElement {
  const location = useRouter();

  return (
    <Head>
      <title key="head-title">{ title }</title>
      <meta name="title" content={metaTitle ?? title} key="title" />
      <meta name="description" content={description} key="description" />
      <meta property="og:title" content={ogTitle ?? title} key="og:title" />
      <meta property="og:type" content={ogType ?? 'website'} key="og:type" />
      <meta
        property="og:url"
        content={`${EVENT_HOST}${location.pathname}`}
        key="og:url"
      />
      <meta property="og:description" content={ogDescription ?? description} key="og:description" />
      { image && (
        <meta property="og:image" content={image} key="og:image" />
      ) }
      { siteName && (
        <meta property="og:site_name" content={siteName} key="og:site_name" />
      ) }
      { webviewTitle && (
        <meta name="webview-title" content={webviewTitle} key="webview-title" />
      ) }
      { canonical && (
        <link rel="canonical" href={canonical} />
      ) }
      { pageId && (
        <meta name="bucket-log:page_id" content={pageId} />
      ) }
      { pageParams && (
        <meta name="bucket-log:page_params" content={JSON.stringify(pageParams)} />
      ) }
    </Head>
  );
}
